import { render, staticRenderFns } from "./TaskAttachmentCard.vue?vue&type=template&id=8a2a4308&scoped=true"
import script from "./TaskAttachmentCard.vue?vue&type=script&lang=js"
export * from "./TaskAttachmentCard.vue?vue&type=script&lang=js"
import style0 from "./TaskAttachmentCard.vue?vue&type=style&index=0&id=8a2a4308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2a4308",
  null
  
)

export default component.exports